import raw from "@/categories.json";
import {
  Home, ShoppingCart, UtensilsCrossed, Pill, Package, FileText, Landmark,
  ShieldCheck, Receipt, Car, Plane, Users, Smile, PawPrint, Sparkles, Gift,
  Hourglass, Truck, HardHat, Briefcase, BarChart3, KeyRound, Cross, Leaf,
  PackageOpen, PlusCircle, Tag,
} from "lucide-react";

const ICONS = {
  home: Home,
  cart: ShoppingCart,
  restaurant: UtensilsCrossed,
  medkit: Pill,
  cube: Package,
  document: FileText,
  business: Landmark,
  "shield-checkmark": ShieldCheck,
  receipt: Receipt,
  car: Car,
  airplane: Plane,
  people: Users,
  happy: Smile,
  paw: PawPrint,
  sparkles: Sparkles,
  gift: Gift,
  hourglass: Hourglass,
  move: Truck,
  construct: HardHat,
  briefcase: Briefcase,
  "bar-chart": BarChart3,
  key: KeyRound,
  medical: Cross,
  leaf: Leaf,
  "cube-outline": PackageOpen,
  "add-circle": PlusCircle,
};

export const CATEGORIES = raw.map((c, i) => ({
  ...c,
  id: i + 1,
  Icon: ICONS[c.icon] || Tag,
}));

export const PRICED = CATEGORIES.filter((c) => c.price_max != null);
export const CUSTOM_WORK = CATEGORIES.find((c) => c.price_max == null);

export const PRICING_NOTE =
  "All prices shown here are only the recommended service charges of the Middle Man.\n\n" +
  "These charges do not include the cost of products, fuel, tolls, parking, courier fees, " +
  "government fees, labour charges, materials, loading/unloading charges, or any other third-party expenses.\n\n" +
  "If the work requires extra distance, waiting time, multiple locations, heavy items, or any special " +
  "requirement, additional charges must be discussed and mutually agreed with the customer BEFORE accepting the work.\n\n" +
  "The app will not allow a Middle Man to enter a service charge above the maximum recommended limit. " +
  "For exceptional cases, the customer and Middle Man should discuss it in advance.";

export const CUSTOM_WORK_NOTE =
  "Charges will be mutually discussed and agreed between the Customer and the Middle Man before accepting the work.";
